import defaultCode from "./defaultCode";
import lesson from "./lesson";
import test from "./test";

export default {
    name: "Search",
    defaultCode,
    lesson,
    test,
    difficulty: 1,
};
